<template>
    <div class="infoCard">
        <b-card header="header" :class="type"> 
            <template v-slot:header  >
                <b-icon class="icons" variant="primary" :icon="data.icon" />
                <h6> {{title}} </h6>
                <div class="buttons"> 
                    <div class="menu">
                         <b-dropdown variant="dark" v-if="data.menus" >
                            <template slot="button-content"> <b-icon :title="$t('account.otherActions')" icon="three-dots" style="color: white" scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>
                            <b-dropdown-item v-for="menu in data.menus" :key="menu.id"> {{ menu.title }} </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div v-if="data.buttons">
                        <b-button v-if="data.buttons.includes('add')" variant="primary" :title="$t('account.list.add')"> <b-icon icon="clipboard-plus" /> </b-button>
                        <b-button v-if="data.buttons.includes('edit')" variant="info" :title="$t('account.list.edit')"><b-icon icon="pencil-square" /></b-button>
                        <b-button v-if="data.buttons.includes('delete')" variant="danger" :title="$t('account.list.delete')"><b-icon icon="trash-fill" /></b-button>
                    </div>
                    
                </div>
            </template>
            <ul v-if="dataType=='list'" class="info">
                <li v-for="field in fields[data.key]" :key="field.key">
                    <strong> {{field.label}} </strong> 
                    <span v-if="field.isArray">  <b-badge v-for="element in data[field.key]" :key="element.id" :variant="element.type"> {{element.name}} </b-badge> </span>
                    <span v-else> {{ data[field.key] }} </span>
                </li>
            </ul>
            <b-table-simple v-if="dataType=='table'">
                <b-thead>
                    <b-th  v-for="field in fields[data.key]" :key="field.key" > {{field.label}} </b-th>
                </b-thead>
                <b-tbody>
                    <b-tr  v-for="item in data.data" :key="item.key"> 
                        <b-td v-for="field in fields[data.key]" :key="field.key"> 
                            <b-icon v-if=" item[field.key] === true" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                            <b-icon v-else-if=" item[field.key] === false" icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                            <div v-else-if="field.key == 'phones'"> 
                                 {{ item[field.key][0] }}
                                 
                                 <span v-if="item[field.key].length > 1 "> 
                                    <b-icon class="otherPhones" :id="'otherPhone'+item['no']" :title="$t('account.otherPhones')" icon="telephone-outbound-fill" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon> 
                                    <b-tooltip :target="'otherPhone'+item['no']" triggers="click">
                                        <ul class="others">
                                            <li v-for="phone in item[field.key]" :key="phone.id"> {{ phone }}</li>
                                        </ul>
                                    </b-tooltip>
                                 </span>
                            </div>
                             <div v-else-if="field.key == 'subscribes'"> 
                                 <span v-for="sub in item[field.key]" :key="sub.id"> 
                                     <b-badge  :id="'sub'+sub.key" :variant="sub.type"> {{sub.name}} </b-badge> 
                                    <b-tooltip v-if="sub.users" :target="'sub'+sub.key" triggers="click">
                                        <ul class="others" >
                                            <li v-for="user in sub.users" :key="user.id">{{user}}</li>
                                        </ul>
                                    </b-tooltip>
                                 </span>
                            </div>
                            <p v-else> {{ item[field.key] }}</p>
                            
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
    </div>
</template>

<script>

export default {
    name: "AccountInfoCard",
    props:{
        info: Array,
        fields: Object,
        type: String,
        title: String,
        dataType: String,
    }
}
</script>

<style scoped>
    @import "../styles/infoCard.min.css";

</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/InfoCard.vue